import "core-js/modules/es.array.reverse.js";
var _dec, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, makeObservable } from "mobx";
import isDefined from "../../Core/isDefined";
import { CompositeBarModel } from "../CompositeBar/CompositeBarModel";
export const OVERFLOW_ITEM_ID = "overflow-item";
let MapNavigationModel = (_dec = action.bound, _class = class MapNavigationModel extends CompositeBarModel {
  constructor(terria, items, options) {
    super(items, options);
    this.terria = terria;
    makeObservable(this);
  }
  addItem(newItem, requestedIndex) {
    const elementConfig = this.terria.elements.get(newItem.id);
    if (elementConfig && isDefined(elementConfig.visible)) {
      newItem.controller.setVisible(elementConfig.visible);
    }
    super.add(newItem, requestedIndex);
  }
  createCompositeBarItem(item) {
    return item;
  }
}, _applyDecoratedDescriptor(_class.prototype, "addItem", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "addItem"), _class.prototype), _class);
export { MapNavigationModel as default };